export default {
  default: [
    {
      path: "/rvt-rapportage",
      name: "statistic-reports",
      component: () => import("./views/StatisticListView.vue")
    }
  ]
};
